export default "__VITE_ASSET__OC6BCcil__"